export default class ImageCarouselWithThumbnails {
	constructor(config) {
		this.el =
			config.el || document.querySelector(".carouselWithThumbnails");
		this.carousel = this.el.querySelector(".carousel");
		this.thumbnails = this.el.querySelectorAll(
			".carouselWithThumbnails__thumbnail"
		);
		this.slides = this.el.querySelectorAll(".carousel__slide");
		this.grabClass = "carousel--grabbing";
		this.track = this.el.querySelector(".carousel__track");
		this.showLargeClass = "carousel--show-large";
		this.isCompact = this.el.classList.contains("carousel--compact");
		this.slidesLength = this.el.querySelectorAll(".carousel__slide").length;
		this.showAllThumbnails = false;
		this.showMoreLessToggleBtn = this.el.querySelector(
			".carouselWithThumbnails__viewmore"
		);
		this.hidePagination = this.el.classList.contains(
			"carouselWithThumbnails--hide-pagination"
		);
		this.showAsCarousel = this.slidesLength > 1;
		this.carouselComponent = utilities.dataStorage.get(
			this.carousel,
			"component"
		);
		this.caption = this.el.querySelector(".carousel__caption");
		this.thumbnails[0].classList.add(
			"carouselWithThumbnails__thumbnail--selected"
		);
		this.init();
	}
	init() {
		const self = this;
		this.addEventListeners();
		this.selectThumbnail(0);
		if (utilities.isMobile() && this.slidesLength > 7) {
			this.el.classList.remove("carouselWithThumbnails--hide-pagination");
		} else if (this.slidesLength > 12) {
			this.el.classList.remove("carouselWithThumbnails--hide-pagination");
		}
	}
	addEventListeners() {
		const self = this;
		this.carousel.addEventListener("carousel/changeSlide", function(
			element
		) {
			const index = element.detail.index;
			self.selectThumbnail(index);
			if (utilities.isMobile() && index > 7) {
				self.showAll();
			} else if (index > 11) {
				self.showAll();
			}
		});
		self.thumbnails.forEach(thumbnail => {
			thumbnail.addEventListener("click", function(event) {
				const index = Array.from(thumbnail.parentNode.children).indexOf(
					thumbnail
				);
				self.selectThumbnail(index);
				self.gotoSlide(index);
			});
			thumbnail.addEventListener("keyup", function(event) {
				if (event.keyCode === utilities.keys.enter) {
					const index = Array.from(
						thumbnail.parentNode.children
					).indexOf(thumbnail);
					self.selectThumbnail(index);
					self.gotoSlide(index);
				}
			});
		});
		if (this.showMoreLessToggleBtn) {
			this.showMoreLessToggleBtn.addEventListener("click", event => {
				self.toggleShowMore();
			});
		}
	}
	toggleShowMore() {
		const self = this;
		if (!self.showAllThumbnails) {
			self.showAll();
			self.showAllThumbnails = true;
		} else {
			self.showLess();
			self.showAllThumbnails = false;
		}
	}
	showAll() {
		this.showAllThumbnails = true;
		this.el.classList.add("carouselWithThumbnails--showall");
	}
	showLess() {
		this.showAllThumbnails = false;
		this.el.classList.remove("carouselWithThumbnails--showall");
	}
	selectThumbnail(index) {
		const self = this;
		const thumbnail = self.thumbnails[index];
		self.thumbnails.forEach(thumbnail => {
			utilities.setAriaProp(thumbnail, "current", false);
			thumbnail.tabIndex = "0";
			thumbnail.classList.remove(
				"carouselWithThumbnails__thumbnail--selected"
			);
		});
		// add figcaption text for carouselWithThumbnails
		const caption = this.caption;
		if (this.slides[index].querySelector("figcaption")) {
			caption.innerHTML = this.slides[index].querySelector(
				"figcaption"
			).innerHTML;
		} else {
			caption.innerHTML = "";
		}
		thumbnail.classList.add("carouselWithThumbnails__thumbnail--selected");
		thumbnail.tabIndex = "-1";
		utilities.setAriaProp(thumbnail, "current", true);
	}
	gotoSlide(index) {
		const self = this;
		self.carouselComponent.gotoSlide(index);
	}
}
